import React, { createContext } from 'react';

const VerificationContext = createContext();

export default VerificationContext;
